import * as React from "react";
import Button from "../Button";
import { CallWidgetConfig, QuestionType, SurveyQuestion } from "../../types";
import { useState, useCallback, useEffect, useRef } from "react";
import StoreContainer from "../../stores/StoreContainer";
import VisitorPhoneQuestion from "../Survey/controls/VisitorPhoneQuestion";

interface Props {
  config: CallWidgetConfig;
}

export default function CallWidget(props: Props) {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const mountedRef = useRef(true);
  const surveyQuestion: SurveyQuestion = {
    UseCountryCode: props.config.UseCountryCode,
    DefaultSelectText: props.config.DefaultCountryCode,
    QuestionText: props.config.InputLabel,
    Required: false,
    QuestionID: 0,
    DisplayWidth: 0,
    HiddenField: false,
    Html: "",
    InvalidEmailMessage: "",
    KBSearchQuestion: false,
    MaskVisitorPhone: props.config.MaskVisitorPhone,
    PlaceholderText: "",
    Priority: 1,
    QuestionType: QuestionType.VisitorPhone,
    SpecifiedGroupIds: null,
    SpecifiedGroupLabelText: null,
    SurveyID: 0,
    SurveyQuestionChoices: null,
    ValidationFailedMessage: "",
    VariableName: null
  };

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const connect = useCallback(async () => {
    try {
      await StoreContainer.EngagementStore.beginClickToCall([], phoneNumber);
    } catch (ex) {
      setError("Call was unable to be requested at this time");
    }
  }, [phoneNumber]);

  const onChange = useCallback(
    (question, answer) => {
      setPhoneNumber(answer);
    },
    [phoneNumber]
  );

  if (!props.config || !props.config.Enabled) {
    return null;
  }

  return (
    <>
      <div className="landing-widget kb-widget">
        {props.config.SideImageUrl && (
          <>
            {props.config.SideImageGradientEnabled && (
              <div className="widget-gradient" />
            )}
            <div className="widget-side-img" />
          </>
        )}
        <div className="widget-body">
          <div className="widget-message">{props.config.LabelText}</div>
          <div className="widget-divider" />
          <div className="widget-form-container">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                connect();
              }}
            >
              <div className="velaro-form-group">
                <VisitorPhoneQuestion
                  question={surveyQuestion}
                  error={error}
                  onChange={onChange}
                />
              </div>
              <Button
                disabled={loading}
                type="submit"
                className="landing-widget-button"
                variant="primary"
              >
                {loading ? "Submitting..." : props.config.ButtonLabel}
              </Button>
              {props.config.ShowExternalPhoneNumber && (
                <a
                  className="velaro-btn primary landing-widget-button"
                  href={"tel:" + props.config.ExternalPhoneNumber}
                >
                  {props.config.ExternalPhoneNumberText}
                </a>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
